import { FeatureFlagProvider, UserContext } from "./FeatureFlagProvider";

export default class DefaultFeatureFlagProvider extends FeatureFlagProvider {
  
  constructor(sdkKey, environment) {
    super();
    this.flags = {
      //"sample_feature_flag": true,
      "aws_connect_enabled": true
    }
  }

  initialize(user = new UserContext(1, "test@email.com")) {
  }

  getFeatureFlagValue(key, defaultValue, contextID) {
    const value = this.flags[key];
    if (value)
      return value;
    return false;
  }
}
